import React, { useState } from "react";
import "./styles.css";
import gif from "../../../components/assets/j.gif";

const ModalComponent = ({
  appointmentSelected,
  closeModalInfoPatientAndAppointment,
  callApiConfirmAppointment,
  setAppointment,
  isLoadingModal,
}) => {
  const [observations, setObservations] = useState("");
  const hour = appointmentSelected.hour.split(" - ")[0];
  const [day, month, year] = appointmentSelected.date.split("/");

  const monthNames = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const monthName = monthNames[Number(month) - 1];

  const clickOutsideModal = (event) => {
    if (!event.target.closest(".modal-content")) {
      closeModalInfoPatientAndAppointment();
    }
  };

  const observationsChange = (event) => {
    const value = event.target.value;
    setObservations(value);
  };

  const saveObservations = () => {
    setAppointment((prevAppointment) => ({
      ...prevAppointment,
      observations: observations,
    }));
  };

  const confirmCita = () => {
    saveObservations();
    callApiConfirmAppointment();
  };

  return (
    <div className="modal-container" onClick={clickOutsideModal}>
      <div className="modal-content">
        <h2 className="titleInfoModalConfirm">Información de la cita</h2>
        {isLoadingModal ? (
          <div className="loadingContainerModal">
            <img src={gif} alt="Loading" className="loadingGifModal" />
          </div>
        ) : (
          <div>
            <p>{appointmentSelected.reason.title}</p>
            <p>
              Cuando: {appointmentSelected.dayOfWeek}, {day} de {monthName} del{" "}
              {year}
            </p>
            <p>Hora: {hour}</p>
            <p>Con: {appointmentSelected.doctor.name}</p>
            <p>Observaciones: </p>
            <textarea
              className="observationsModalConfirm"
              onChange={observationsChange}
              onBlur={saveObservations}
            ></textarea>
            <div className="containerButtonModalConfirm">
              <button className="btnModalConfirm" onClick={confirmCita}>
                Confirmar cita
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalComponent;
